module.exports = __webpack_public_path__ + "img/SuccessTurtle2.406201e0.gif";